module.exports = __webpack_public_path__ + "img/grat-vein.1c89609f.png";